export default "__VITE_ASSET__badec42c__"